import { Button, Form, Input, Typography } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { extractErrorMessage } from '@shared/api';
import { useRequestPasswordResetMutation } from '../api/mutations';

const { Title, Text } = Typography;

interface ForgotFormValues {
  email: string;
}

export function ForgotPasswordForm() {
  const navigate = useNavigate();
  const [form] = Form.useForm<ForgotFormValues>();
  const mutation = useRequestPasswordResetMutation();

  const handleSubmit = async (values: ForgotFormValues) => {
    try {
      await mutation.mutateAsync(values);
      navigate('/reset-password', { state: { email: values.email } });
    } catch {
      // см. error
    }
  };

  const errorMessage = mutation.error ? extractErrorMessage(mutation.error) : null;

  return (
    <div>
      <Title level={3} style={{ marginTop: 0, marginBottom: 4 }}>
        Восстановление пароля
      </Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
        Укажите email — мы отправим код для смены пароля
      </Text>

      <Form<ForgotFormValues>
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        requiredMark={false}
      >
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Введите email' },
            { type: 'email', message: 'Некорректный email' },
          ]}
        >
          <Input size="large" type="email" placeholder="user@example.com" autoFocus />
        </Form.Item>

        {errorMessage && (
          <div style={{ marginBottom: 16, color: '#DC2626', fontSize: 13 }}>{errorMessage}</div>
        )}

        <Button type="primary" htmlType="submit" size="large" block loading={mutation.isPending}>
          Отправить код
        </Button>

        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <Link to="/login">Назад ко входу</Link>
        </div>
      </Form>
    </div>
  );
}
